import { combineReducers } from 'redux';

import {
    SET_FLASHING_TICKET_PARTNER_ID,
    REQUEST_FORM_SUBMIT_FLASHING_TICKET,
    SUCCESS_FORM_SUBMIT_FLASHING_TICKET,
    FAILURE_FORM_SUBMIT_FLASHING_TICKET
} from './constants';

const partnerId = (state = -1, action) => {
    switch (action.type) {
        case SET_FLASHING_TICKET_PARTNER_ID:
            return action.id;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_FORM_SUBMIT_FLASHING_TICKET:
            return true;
        case SUCCESS_FORM_SUBMIT_FLASHING_TICKET:
        case FAILURE_FORM_SUBMIT_FLASHING_TICKET:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_FORM_SUBMIT_FLASHING_TICKET:
            return action.response.message;
        case SUCCESS_FORM_SUBMIT_FLASHING_TICKET:
        case REQUEST_FORM_SUBMIT_FLASHING_TICKET:
            return '';
        default:
            return state;
    }
};

const successFlashingTicketSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_FORM_SUBMIT_FLASHING_TICKET:
            return true;
        case REQUEST_FORM_SUBMIT_FLASHING_TICKET:
        case FAILURE_FORM_SUBMIT_FLASHING_TICKET:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    partnerId,
    successFlashingTicketSubmit,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/flashing-ticket/reducer.js